export default "__VITE_ASSET__BAovCjvc__"